/// nav menu anchor li name anchor-nav-label
if (document.querySelector(".comp-nav-page-anchor")) {
	/// smooth scroll
	var compNavPageAnchorLink =
		document.getElementsByClassName("anchor-nav-label");
	var compNavPageAnchorLinkLength = compNavPageAnchorLink.length;
	for (var i = 0; i < compNavPageAnchorLinkLength; i++) {
		compNavPageAnchorLink[i].addEventListener("click", function (e) {
			e.preventDefault();
			if (document.querySelector(".comp-nav-page-anchor li.selected")) {
				document.querySelector(".comp-nav-page-anchor li.selected").classList.remove("selected");
			}
			
			this.classList.add("selected");
			var compNavPageAnchorLinkHref =
				this.getElementsByTagName("a")[0].getAttribute("href");
			var compNavPageAnchorLinkHrefSplit = compNavPageAnchorLinkHref.split("#");
			var compNavPageAnchorLinkHrefSplitLength =
				compNavPageAnchorLinkHrefSplit.length;
			if (compNavPageAnchorLinkHrefSplitLength > 1) {
				var compNavPageAnchorLinkHrefSplitId =
					compNavPageAnchorLinkHrefSplit[1];
				var compNavPageAnchorLinkHrefSplitIdLength =
					compNavPageAnchorLinkHrefSplitId.length;
				if (compNavPageAnchorLinkHrefSplitIdLength > 0) {
					var compNavPageAnchorLinkHrefSplitIdElement = document.getElementById(
						compNavPageAnchorLinkHrefSplitId
					);
					if (compNavPageAnchorLinkHrefSplitIdElement) {
						var compNavPageAnchorLinkHrefSplitIdElementOffsetTop =
							compNavPageAnchorLinkHrefSplitIdElement.offsetTop;
						window.scrollTo({
							top: compNavPageAnchorLinkHrefSplitIdElementOffsetTop,
							behavior: "smooth",
						});
					}
				}
			}
		});
	}

	/// stop navbar being fixed when it reaches comp-other-card
	var elementStop =
		document.querySelector(".comp-other-card").offsetTop -
		document.querySelector(".comp-other-card").offsetHeight;
	document.addEventListener("scroll", (event) => {
		if (window.scrollY >= elementStop) {
			document
				.querySelector(".comp-nav-page-anchor")
				.classList.remove("fixedbar");
			document.querySelector(".comp-nav-page-anchor").style["top"] =
				elementStop + 230 + "px";
		}

		if (window.scrollY <= elementStop) {
			document.querySelector(".comp-nav-page-anchor").classList.add("fixedbar");
			document.querySelector(".comp-nav-page-anchor").style["top"] = "230px";
		}
	});

	/// Nav-link's to selected as you scroll through sections
	const sections = document.querySelectorAll(".section-label");
	const navLi = document.querySelectorAll(".comp-nav-page-anchor li");
    // console.log(navLi)
	window.onscroll = () => {
		var current = "";
		sections.forEach((section) => {
			const sectionTop = section.offsetTop;
			if (scrollY >= sectionTop - 300) {
				current = section.getAttribute("id");
                // console.log(current)
			}
		});

		navLi.forEach((li) => {
			li.classList.remove("selected");
			if (li.classList.contains(current)) {
				li.classList.add("selected");
			}
		});
	};
}
